import CircularProgress from '@mui/material/CircularProgress'
import LinearProgress from '@mui/material/LinearProgress'
import FileItem, { FileItemProps } from './HomeFileItem'
import * as Def from './HomeModuleDef'
import './styles/homemodule.css'

enum ProgressType {
  Circular,
  Linear,
}

interface HomeFileUploaderMessageProps extends FileItemProps {
  state: Def.ModuleState
  progressType?: ProgressType
}

/**
 * Get the message inside the FileUploader depending on the given state.
 * @param state The state.
 * @returns A string containing the message.
 */
const HomeFileUploaderMessageComp = (props: HomeFileUploaderMessageProps) => {
  function progressAndMsgComp(title: string, warning?: string) {
    return (
      <div className="contents">
        {ProgressType.Circular === props.progressType ? (
          <div className="flex flex-row space-x-5 justify-center items-center">
            <CircularProgress
              size={20}
              color={'inherit'}
              style={{ color: 'var(--accentColor)' }}
            />
            <div>{title}</div>
          </div>
        ) : (
          <div className="message">
            <div className="progressTitle">{title}</div>
            {warning && <div className="progressWarning">{warning}</div>}

            <LinearProgress
              color={'inherit'}
              style={{ color: 'var(--accentColor)' }}
            />
          </div>
        )}

        <FileItem
          fileName={props.fileName}
          processingResult={props.processingResult}
          handleDownloadResult={props.handleDownloadResult}
        />
      </div>
    )
  }

  switch (props.state) {
    case Def.ModuleState.AnalyzingFile:
      return progressAndMsgComp(
        'Checking file format...',
        'Please stay on this page while the upload is running'
      )

    case Def.ModuleState.Uploading:
      return progressAndMsgComp(
        'Uploading file...',
        'Please stay on this page while the upload is running'
      )

    case Def.ModuleState.PreparingProcess:
      return progressAndMsgComp(
        'Preparing processing...',
        'Please stay on this page while the upload is running'
      )

    case Def.ModuleState.Processing:
      return progressAndMsgComp('Processing...')

    default:
      return null
  }
}

export default HomeFileUploaderMessageComp
